import { initializeAnalytics } from "@repo/analytics/instrumentation-client";
import { initializeSentry } from "@repo/observability/client";
import * as Sentry from "@sentry/nextjs";

if (!/^\/presentations?\//.test(window.location.pathname)) {
  initializeSentry();
  initializeAnalytics();
}

export const onRouterTransitionStart: typeof Sentry.captureRouterTransitionStart = (...args) => {
  if (/^\/presentations?\//.test(String(args[0]))) return;
  return Sentry.captureRouterTransitionStart(...args);
};
